import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'ngx-moment';

import { NgxCaptchaModule } from "ngx-captcha";

import { AllDirectoryComponent } from './all-directory/all-directory.component';
import { ActiveDirectoryComponent } from './active-directory/active-directory.component';
import { BadgeComponent } from "./badge/badge.component";
import { BadgeManagementComponent } from "./badge/management/badge-management.component";
import { CVPurchaseComponent } from './shared/directory/list/purchase/cv-purchase.component';
import { CVPurchaseService } from './shared/directory/list/purchase/cv-purchase.service';
import { ReceiptRequestComponent } from './shared/directory/list/purchase/receipt/receipt-rquest.coponent';
import { DirectoryComponent } from './shared/directory/directory.component';
import { DirectoryListComponent } from "./shared/directory/list/list.component";
import { DirectoryMocksService } from "./shared/services/directory-mocks.service";
import { DirectoryService } from "./shared/services/directory.service";

import { PagingComponent } from "./shared/directory/list/paging/paging.component";

import { SearchFormComponent } from "./shared/directory/search-form/search-form.component";
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule, 
    ReactiveFormsModule,
    RouterModule,
    MomentModule,
    NgxCaptchaModule,
    NgxMaskModule
  ],
  providers: [
    CVPurchaseService,
    DirectoryMocksService, 
    DirectoryService,    
  ],
  declarations: [
    ActiveDirectoryComponent,
    AllDirectoryComponent,
    BadgeComponent,
    BadgeManagementComponent,
    CVPurchaseComponent,
    ReceiptRequestComponent,
    DirectoryComponent,
    DirectoryListComponent,
    PagingComponent,
    SearchFormComponent
  ]
})
export class DirectoryModule { }
